import { render } from "./PublisherPayoutInformation.vue?vue&type=template&id=0d43e486&ts=true&lang=pug"
import script from "./PublisherPayoutInformation.vue?vue&type=script&lang=ts"
export * from "./PublisherPayoutInformation.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__